module.exports = __webpack_public_path__ + "media/images/bullet-845d17d55cc73cfbe8f7c8ef099b3741.png";